{
  "BULK_ACTION": {
    "CONVERSATIONS_SELECTED": "{conversationCount} konuşma seçildi",
    "NONE": "Hiç",
    "CLEAR_SELECTION": "Clear",
    "ASSIGN_AGENT_CONFIRMATION_LABEL": "Are you sure you want to assign {n} conversation to {agentName}? | Are you sure you want to assign {n} conversations to {agentName}?",
    "UNASSIGN_AGENT_CONFIRMATION_LABEL": "Are you sure you want to unassign {n} conversation? | Are you sure you want to unassign {n} conversations?",
    "YES": "Evet",
    "CANCEL": "İptal Et",
    "SEARCH_INPUT_PLACEHOLDER": "Ara",
    "ASSIGN_AGENT_TOOLTIP": "Temsilci ata",
    "ASSIGN_TEAM_TOOLTIP": "Takım ata",
    "ASSIGN_SUCCESFUL": "Görüşmeler başarıyla atandı.",
    "ASSIGN_FAILED": "Görüşmeler atanırken bir hata oluştu. Lütfen tekrar deneyin.",
    "RESOLVE_SUCCESFUL": "Görüşmeler başarıyla çözüldü.",
    "RESOLVE_FAILED": "Görüşmeler çözülürken bir hata oluştu. Lütfen tekrar deneyin.",
    "ALL_CONVERSATIONS_SELECTED_ALERT": "Bu sayfada yalnızca seçili konuşmalar gösterilmektedir.",
    "UPDATE": {
      "CHANGE_STATUS": "Durumu değiştir",
      "SNOOZE_UNTIL": "Sustur",
      "UPDATE_SUCCESFUL": "Konuşma durumu başarıyla güncellendi.",
      "UPDATE_FAILED": "Görüşmeler güncellenirken bir hata oluştu. Lütfen tekrar deneyin."
    },
    "RESOLVE": {
      "ALL_MISSING_ATTRIBUTES": "Cannot resolve conversations due to missing required attributes",
      "PARTIAL_SUCCESS": "Some conversations need required attributes before resolving and were skipped"
    },
    "LABELS": {
      "ASSIGN_LABELS": "Etiket atama",
      "REMOVE_LABELS": "Remove labels",
      "ASSIGN_SELECTED_LABELS": "Seçili etiketleri atama",
      "REMOVE_SELECTED_LABELS": "Remove selected labels",
      "ASSIGN_SUCCESFUL": "Etiketler başarıyla atandı.",
      "ASSIGN_FAILED": "Etiketler atanırken bir hata oluştu. Lütfen tekrar deneyin.",
      "REMOVE_SUCCESFUL": "Labels removed successfully.",
      "REMOVE_FAILED": "Failed to remove labels. Please try again."
    },
    "TEAMS": {
      "NONE": "Hiçbiri",
      "ASSIGN_TEAM_CONFIRMATION_LABEL": "Are you sure you want to assign {n} conversation to {teamName}? | Are you sure you want to assign {n} conversations to {teamName}?",
      "UNASSIGN_TEAM_CONFIRMATION_LABEL": "Are you sure you want to unassign {n} conversation? | Are you sure you want to unassign {n} conversations?",
      "ASSIGN_SUCCESFUL": "Teams assigned successfully.",
      "ASSIGN_FAILED": "Takımlar atanırken bir hata oluştu. Lütfen tekrar deneyin."
    }
  }
}
